import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getPeriode } from './periode-evaluation.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const PeriodeEvaluationDetail = (props: RouteComponentProps<{ ecoleid: string; anneeScolaireId?: string; id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getPeriode(props.match.params.id));
  }, []);

  const periodeEntity = useAppSelector(state => state.periodeEvaluation.entity);

  const goBack = () => props.history.goBack();
  return (
    <Row className="justify-content-center">
      <Col md="8">
        <h2 data-cy="periodeDetailsHeading">
          <Translate contentKey="korischoolApp.periodeEvaluation.detail.title">Période d`&apos;`évaluation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{periodeEntity.id}</dd>
          <dt>
            <span id="nom">
              <Translate contentKey="korischoolApp.periodeEvaluation.nom">Nom</Translate>
            </span>
          </dt>
          <dd>{periodeEntity.nom}</dd>
          <dt>
            <span id="dateDebut">
              <Translate contentKey="korischoolApp.periodeEvaluation.dateDebut">Date début</Translate>
            </span>
          </dt>
          <dd>{periodeEntity.dateDebut}</dd>
          <dt>
            <span id="dateFin">
              <Translate contentKey="korischoolApp.periodeEvaluation.dateFin">Date fin</Translate>
            </span>
          </dt>
          <dd>{periodeEntity.dateFin}</dd>
          <dt>
            <span id="ordre">
              <Translate contentKey="korischoolApp.periodeEvaluation.ordre">Ordre</Translate>
            </span>
          </dt>
          <dd>{periodeEntity.ordre}</dd>
        </dl>
        <Button onClick={goBack} color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button
          tag={Link}
          to={
            props.match.params.anneeScolaireId
              ? `/periode-evaluation/${periodeEntity.ecoleId}/${props.match.params.anneeScolaireId}/${periodeEntity.id}/edit`
              : `/periode-evaluation/${periodeEntity.ecoleId}/${periodeEntity.id}/edit`
          }
          replace
          color="primary"
        >
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PeriodeEvaluationDetail;
